import { AccessDeniedLayout, Content, LockIcon } from './AccessDeniedLayout';

type AccessDeniedProps = {
    title?: string;
    contentTitle?: string;
    subtitle?: string;
    subtitle2?: string;
};

export default function AccessDenied({
    title,
    contentTitle,
    subtitle,
    subtitle2,
}: AccessDeniedProps) {
    return (
        <AccessDeniedLayout title={title}>
            <div className="alli-mx-4 alli-mt-40 alli-flex alli-flex-col alli-items-center alli-text-center">
                <LockIcon />
                <Content
                    title={contentTitle}
                    subtitle={subtitle}
                    subtitle2={subtitle2}
                    accessType="accessDenied"
                />
            </div>
        </AccessDeniedLayout>
    );
}
